import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { INDUSTRIES } from '../constants';
import { useLanguage } from '../LanguageContext';

const TABS = ['assurance', 'courtage', 'assistance'];

function IndustryVisual({ industry, visualData }) {
  const colors = {
    courtage:   { bg: '#EFF6FF', accent: '#0055A4' },
    assistance: { bg: '#F0FDF4', accent: '#166534' },
    assurance:  { bg: '#FFF7ED', accent: '#9A3412' },
  };
  const c = colors[industry];
  const v = visualData[industry];

  return (
    <div className="pb-industry-visual" style={{ background: c.bg }}>
      <div style={{
        background: 'white', border: '1px solid rgba(0,0,0,0.06)', borderRadius: 12,
        padding: '20px 24px', width: 220, boxShadow: '0 8px 32px rgba(0,0,0,0.07)',
      }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: c.accent, marginBottom: 12 }}>
          {v.label}
        </div>
        {[85, 62, 91, 74].map((w, i) => (
          <div key={i} style={{ height: 10, background: i === 0 ? c.accent : '#E2E8F0', borderRadius: 4, marginBottom: 8, opacity: i === 0 ? 0.9 : 1, width: `${w}%`, transition: 'width 0.3s ease' }} />
        ))}
        <div style={{ display: 'flex', gap: 6, marginTop: 16 }}>
          {v.statuses.map((label, i) => (
            <span key={label} style={{ fontSize: 10, fontWeight: 600, padding: '3px 8px', borderRadius: 9999, background: i === 0 ? c.accent : '#F1F5F9', color: i === 0 ? 'white' : '#64748B' }}>
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Industries() {
  const { lang }       = useLanguage();
  const industries     = INDUSTRIES[lang];
  const [active, setActive] = useState('assurance');
  const data           = industries[active];

  return (
    <section className="pb-section pb-section-pad" id="solutions" data-testid="pb-industries">
      <div className="pb-container">
        {/* Header */}
        <div style={{ marginBottom: 40 }}>
          <div className="pb-label">{industries.header.label}</div>
          <h2 className="pb-section-title">{industries.header.title}</h2>
          <p className="pb-section-sub">{industries.header.sub}</p>
        </div>

        {/* Tabs */}
        <div className="pb-tabs-list" role="tablist" data-testid="pb-industry-tabs">
          {TABS.map(tab => (
            <button
              key={tab}
              className={`pb-tab-btn${active === tab ? ' active' : ''}`}
              role="tab"
              aria-selected={active === tab}
              onClick={() => setActive(tab)}
              data-testid={`pb-industry-tab-${tab}`}
            >
              {industries[tab].label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="pb-industry-grid" data-testid={`pb-industry-content-${active}`}>
          <div>
            <h3 className="pb-industry-headline">{data.headline}</h3>
            <p className="pb-industry-desc">{data.desc}</p>
            <div className="pb-industry-features">
              {data.features.map(feat => (
                <div key={feat} className="pb-industry-feature">
                  <CheckCircle size={15} color="#0055A4" style={{ flexShrink: 0 }} />
                  <span style={{ fontSize: 14, color: '#0A192F' }}>{feat}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 28 }}>
              <a
                href="mailto:cockpit@pitboardsuite.com"
                className="pb-btn-outline"
                style={{ fontSize: 14, padding: '10px 22px' }}
                data-testid={`pb-industry-cta-${active}`}
              >
                {industries.ctaLabel} — {data.label}
              </a>
            </div>
          </div>
          <IndustryVisual industry={active} visualData={industries.visual} />
        </div>
      </div>
    </section>
  );
}
